import {Component, inject, Input, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AreaSearchFilterModel} from '../../../../../../api/model/Area.model';

interface AreaSearchForm {
  name: FormControl<string>;
  code: FormControl<string>;
  zipCode: FormControl<string>;
}

@Component({
  selector: 'tj-area-search-form',
  templateUrl: './area-search-form.component.html',
  styleUrls: ['./area-search-form.component.scss']
})
export class AreaSearchFormComponent {
  private readonly fb = inject(FormBuilder);

  @Input() filter: AreaSearchFilterModel = {};
  @Input() form: FormGroup<AreaSearchForm>;

  constructor() {
  }

  ngOnInit() {
    const filter = this.filter || {};
    this.form.addControl('name', this.fb.control(filter.name || ''));
    this.form.addControl('code', this.fb.control(filter.code || ''));
    this.form.addControl('zipCode', this.fb.control(filter.zipCode || ''));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filter && changes.filter.currentValue === null) {
      this.filter = {};
    }
  }
}
